import logoRed from "../assets/images/logored.svg";

const UPDATED_AT = "June 10, 2026";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#F6F7F9] px-5 py-6 text-[#1A1A1A] sm:px-8">
      <div className="mx-auto max-w-4xl">
        <header className="mb-6 flex items-center">
          <a href="/" className="inline-flex items-center gap-3" aria-label="Strobe Aviation home">
            <img src={logoRed} alt="Strobe Aviation" className="h-8 w-auto" />
          </a>
        </header>

        <article className="rounded-3xl bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.08)] sm:p-10">
          <p className="text-sm text-black/50">Last updated: {UPDATED_AT}</p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Privacy Policy</h1>
          <p className="mt-4 text-black/65">
            This Privacy Policy explains how Strobe Aviation collects, uses, and protects information through
            the website, broker portal, admin portal, request forms, support messages, and notification tools.
          </p>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Information We Collect</h2>
            <p className="text-black/65">
              We may collect account information such as name, email address, phone number, role, broker
              account membership, and notification preferences.
            </p>
            <p className="text-black/65">
              We may collect request information such as tail number, requested services, priority, airport
              identifier, point-of-contact details, notes, assigned pilot or team, expected timing, timezone,
              and project status.
            </p>
            <p className="text-black/65">
              If you send a help request, we collect the subject, message, and account email needed to respond.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">How We Use Information</h2>
            <p className="text-black/65">
              We use information to operate the portal, manage aviation photography requests, schedule and
              update projects, provide support, maintain account access, and send opted-in transactional
              notifications.
            </p>
            <p className="text-black/65">
              We do not sell personal information. We do not use broker notification phone numbers for
              unrelated marketing campaigns.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Email and SMS Notifications</h2>
            <p className="text-black/65">
              If you enable notifications, we may send email or SMS messages about broker request submissions,
              request edits, deletes, project scheduling, and project status updates. Message frequency varies
              based on account activity.
            </p>
            <p className="text-black/65">
              For SMS notifications, message and data rates may apply. Reply STOP to unsubscribe. For help,
              contact support@strobeaviation.com. You can also update notification preferences in your portal
              settings.
            </p>
            <p className="text-black/65">
              SMS opt-in data and consent are not sold, rented, shared, or transferred to third parties
              or affiliates. SMS consent is used only to send the transactional notifications selected by
              the opted-in portal user.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Service Providers</h2>
            <p className="text-black/65">
              We use trusted service providers to operate the portal and send messages, including Supabase for
              authentication and database services, Resend for email delivery, and Twilio for SMS delivery.
              These providers process information only as needed to provide their services.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Data Access and Security</h2>
            <p className="text-black/65">
              Portal access is role-based. Broker users can access request information for their broker
              account. Admin users can access Strobe Aviation operational information needed to manage requests.
              We use authentication, database permissions, and access controls to help protect portal data.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Your Choices</h2>
            <p className="text-black/65">
              You may update account details and notification preferences in the portal. You may opt out of SMS
              notifications by replying STOP. You may contact support@strobeaviation.com for help with privacy
              questions or account access.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Contact</h2>
            <p className="text-black/65">
              Privacy questions can be sent to support@strobeaviation.com.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}
